export default __webpack_public_path__ + "static/media/Bharjav Joshi.f3de8799.jpg";